import React, {Component} from 'react';
import {Input, Grid} from 'react-spreadsheet-grid';
import Select, {components, DropdownIndicatorProps} from "react-select";
import set from "lodash.set";
import {Button, Col} from "react-bootstrap";
import {Collapse} from "react-collapse";
import Row from "react-bootstrap/Row";
import arrow_up from "../../assets/icons/dark_arrow_up.png";
import arrow_down from "../../assets/icons/dark_arrow_down.png";
import {Typography} from "@material-ui/core";

export class LimingTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            liming_columns: [],
            update: false,
            fertilizers_mineral_list: [],
            isCellChange: []
        }
        this.calculateLiming = this.calculateLiming.bind(this)
        this.calcSum = this.calcSum.bind(this)
        this.setUseInputPrice = this.setUseInputPrice.bind(this)
    }

    componentDidMount() {
        this.populateData();
    }

    calcSum(useInputPrice = false) {
        let sum_dose = 0
        let sum_price = 0
        if (this.state.fertilizers_mineral_list.length !== 0 && this.props.field.length !== 0) {
            // eslint-disable-next-line array-callback-return
            this.props.liming.map((row) => {
                sum_dose = sum_dose + (Number(row.fertilizer_dose) * row.area)
                sum_price = sum_price + (row.price ? Number(row.price) : 0) + (useInputPrice ? Number(row.intro_price) * Number(row.fertilizer_dose) * row.area : 0)
            })
        }
        this.props.setSumPrice(sum_price)
        this.props.setSumDose(sum_dose)
    }

    colorBacklight = (pH, soilId) => {
        const group = this.props.soils.find((soil) => soil.id === soilId).soilGroup.name
        if (group === "Торфяные") {
            if (Number(pH) <= 4)
                return "red-row"
            else if (Number(pH) <= 4.5)
                return "pink-row"
            else if (Number(pH) <= 5.0)
                return "orange-row"
            else if (Number(pH) <= 5.5)
                return "yellow-row"
            else if (Number(pH) <= 6.0)
                return "green-row"
            else if (Number(pH) <= 6.5)
                return "blue-row"
            else return "dark-blue-row"
        } else {
            if (Number(pH) <= 4.5)
                return "red-row"
            else if (Number(pH) <= 5)
                return "pink-row"
            else if (Number(pH) <= 5.5)
                return "orange-row"
            else if (Number(pH) <= 6)
                return "yellow-row"
            else if (Number(pH) <= 6.5)
                return "green-row"
            else if (Number(pH) <= 7)
                return "blue-row"
            else return "dark-blue-row"
        }
    }

    groupSoil(soilId) {
        return this.props.soilGroup.find((value) => value.id === this.props.soils.find(value => value.id === soilId).soilGroupId)
    }

    dose(soilId, humus, ph) {
        try {
            let soilGroup = this.groupSoil(soilId)
            let groupHumus = soilGroup.soilGroupHumus[0]
            // eslint-disable-next-line array-callback-return
            soilGroup.soilGroupHumus.map((r) => {
                if (humus <= r.humus) {
                    groupHumus = r
                }
            })
            let liming = groupHumus.soilGroupPh[0].liming
            // eslint-disable-next-line array-callback-return
            groupHumus.soilGroupPh.map((r) => {
                if (ph <= r.ph) {
                    liming = r.liming
                }
            })
            return liming
        } catch {
            return 0
        }
    }

    calculateLiming() {
        let liming_rows = this.props.liming
        let min
        if (this.state.fertilizers_mineral_list.length > 0) {
            min = this.state.fertilizers_mineral_list[0]
            // eslint-disable-next-line array-callback-return
            this.state.fertilizers_mineral_list.map(r => {
                if (min.element.caO / min.price < r.element.caO / r.price) {
                    min = r
                }
            })
        }
        // eslint-disable-next-line array-callback-return
        liming_rows.map((r) => {
            let dose = this.dose(r.soilId, r.humus, r.pH)
            r.dose = dose
            if (this.state.fertilizers_mineral_list.length > 0) {
                r.fertilizer_dose = (dose / min.element.caO).toFixed(2)
                r.price = min.price * r.fertilizer_dose * r.area
                r.fertilizer_id = min.value
            }
        })
        this.props.setLiming(liming_rows)
        this.setState({
            update: !this.state.update,
            isCellChange: [],
        }, () => this.calcSum(this.props.useInputPrice))

    }

    setUseInputPrice() {
        this.props.setUseInputPrice()
        this.calcSum(!this.props.useInputPrice)
    }

    static renderTable(liming_columns, liming_rows, calculateLiming, sum_dose, sum_price, expand, isExpand,
                       isLimingOpen, useLiming, useInputPrice, setUseInputPrice) {
        return (
            <div id='liming-table-container'>
                <div className="label-btn-container">
                    <Button className="label-button" onClick={expand}> Известкование
                        <img src={isExpand ? arrow_up : arrow_down} className='btn-arrow' alt='arrow'/>
                    </Button>
                </div>
                <Collapse isOpened={isExpand}>
                    <div className={"fertilizer-button-wrapper "+ (isExpand? 'visible': 'invisible')}>
                        <Button className="calculate-liming-button" onClick={calculateLiming}>Рассчитать</Button>
                    </div>
                    <div id="liming_calculation_table" className='input-price-cell'>
                        {/*<input className='input-price-checkbox' type='checkbox' checked={useInputPrice} onClick={setUseInputPrice}/>*/}
                        <Grid
                            columns={liming_columns}
                            rows={liming_rows}
                            rowHeight={75}
                            focusOnSingleClick={true}
                            isScrollable={false}
                            getRowKey={liming_rows => liming_rows.id}
                            disabledCellChecker={(liming_rows, columnId) => {
                                return columnId === 'name' ||
                                    columnId === 'soil' ||
                                    columnId === 'humus' ||
                                    columnId === 'pH' ||
                                    columnId === 'dose' ||
                                    columnId === 'organic' ||
                                    columnId === 'pH' ||
                                    columnId === 'price'
                            }}
                        />

                        <Row className="liming-row">
                            <Col className="liming-total">
                                Итог по
                                полю: {new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 0}).format(sum_dose)} тонн,   &ensp;
                                {new Intl.NumberFormat('ru-RU', {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                }).format(sum_price).replace(',', '.')} руб
                            </Col>
                            <Col className='use-liming'>
                                <label className='checkbox-other' >
                                    <input type="checkbox" checked={isLimingOpen} onChange={useLiming}/>
                                    <span>Использовать в расчетах</span>
                                </label>
                            </Col>
                        </Row>
                    </div>
                </Collapse>
            </div>
        );

    }

    render() {
        const content = this.props.field.length !== 0 ? LimingTable.renderTable(
            this.state.liming_columns,
            this.props.liming,
            this.calculateLiming,
            this.props.sum_dose,
            this.props.sum_price,
            this.props.changeExpand,
            this.props.expand,
            this.props.isLimingOpen,
            this.props.useLiming,
            this.props.useInputPrice,
            this.setUseInputPrice,
            this.calcSum) : <></>
        return (<div key={this.state.update}>{content}</div>)

    }

    async populateData() {
        const numberFormat = new Intl.NumberFormat('ru-RU')
        const priceFormat = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2})

        function formatCell(value, price = false) {
            return value ? (price ? priceFormat : numberFormat).format(value.toString().replace(',', '.')).replace(',', '.') : 0
        }

        const fertilizers_mineral_list_full = this.props.fertilizer_mineral_list
        let fertilizers_mineral_list = fertilizers_mineral_list_full.filter(r => r.type === "Известковое").map((r) => ({
            value: r.id, label: r.name, element: r.element, price: r.price
        }))
        let isCellChange = []
        let isSelectChange = []

        const onLimingChange = (rowId, field) => (value1) => {
            let value = Number(value1.replace(/\s/g, "").replace(',', '.'))
            const rowRegion = this.props.liming.find((row) => {
                return row.id === rowId;
            });
            set(rowRegion, field, value);
            if (field === 'fertilizer_dose' && fertilizers_mineral_list.length > 0) {
                const fertilizer = fertilizers_mineral_list.find((f) => f.value === rowRegion.fertilizer_id)
                if (fertilizer)
                    set(rowRegion, 'price', (fertilizer.price * value * rowRegion.area))
                else
                    set(rowRegion, 'price', 0)
            }
            const newCellChange = this.state.isCellChange.concat(rowId)
            this.setState({isCellChange: newCellChange})
            this.calcSum(this.props.useInputPrice)
        }
        const onFertilizerChange = (rowId, field) => (value) => {
            const row = this.props.liming.find((row) => {
                return row.id === rowId;
            });
            let fertilizer = this.props.fertilizer_mineral_list.find((f) => {
                return f.id === value.value;
            })
            row.fertilizer_id = fertilizer.id
            row.fertilizer_dose = (row.dose / fertilizer.element.caO).toFixed(2)
            set(row, field, value.value)
            set(row, 'price', (fertilizer.price * row.fertilizer_dose * row.area))
            this.calcSum(this.props.useInputPrice)
            isSelectChange.push(rowId)
            this.setState({update: !this.state.update})
        }

        const DropdownIndicator = (props: DropdownIndicatorProps<ColourOption, true>) => {
            return (
                <components.DropdownIndicator {...props}>
                    <img src={props.selectProps.menuIsOpen ? arrow_up : arrow_down} alt='arrow-down'
                         className='arrow'></img>
                </components.DropdownIndicator>
            );
        };

        function NoOptionsMessage(props) {
            if (props.options.length) return null;
            return <Typography className='no-options-label' {...props.innerProps}>Нет данных</Typography>;
        }

        const liming_columns = [
            {
                title: 'Наим. эл. участка',
                value: (row, {focus}) => {
                    return (
                        <div className={this.colorBacklight(row.pH, row.soilId)}>
                            <Input
                                value={row.name}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'name',
                width: 12,
            }, {
                title: 'pH',
                value: (row, {focus}) => {
                    return (
                        <div className={this.colorBacklight(row.pH, row.soilId)}>
                            <Input
                                value={formatCell(row.pH)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'pH',
                width: 8,
            }, {
                title: 'Доза изв. мелиорантов,\nт/га CaCO₃',
                value: (row, {focus}) => {
                    return (
                        <div className={this.colorBacklight(row.pH, row.soilId)}>
                            <Input
                                value={formatCell(row.dose)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'dose',
                width: 15
            }, {
                title: 'Тип минерального удобрения',
                value: (row, {focus}) => {
                    return (
                        <div
                            className={this.colorBacklight(row.pH, row.soilId) + ' ' + (isSelectChange.includes(row.id) ? 'change-cell' : '')}>
                            <Select
                                maxMenuHeight="229px"
                                components={{DropdownIndicator, NoOptionsMessage}}
                                theme={(theme) => ({
                                    ...theme,
                                    border: '1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    colors: {
                                        ...theme.colors,
                                        primary: '#ABB3D1',
                                    },
                                })}
                                styles={{
                                    container: (baseStyles, state) => ({
                                        ...baseStyles,
                                        margin: '0 auto',
                                        marginTop: '10px',
                                        width: '90%',
                                        height: '53px',
                                    }),
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        background: state.isFocused ? '#fff' : '#E9EAEE',
                                        height: '53px',
                                        width: '100%',
                                    }),
                                    menu: (baseStyles, state) => ({
                                        ...baseStyles,
                                        border: ' 1px solid #ABB3D1',
                                        borderRadius: '10px',
                                        margin: '0',
                                    }),
                                    option: (baseStyles, state) => ({
                                        ...baseStyles,
                                        height: '45px',
                                        backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                    }),
                                    menuList: (baseStyles, state) => ({
                                        ...baseStyles,
                                        paddingRight: '13px !important',
                                        "::-webkit-scrollbar":{
                                            width: '3px !important'
                                        },
                                        "::-webkit-scrollbar-track": {
                                            background: '#E2E4EF !important',
                                            borderRadius: '6px !important'
                                        },
                                        "::-webkit-scrollbar-thumb":{
                                            background: ' #ABB3D1 !important',
                                            borderRadius: '6px !important'
                                        },
                                        "::-webkit-scrollbar-thumb:hover":{
                                            background: ' #ABB3D1 !important',
                                        }
                                    })
                                }}
                                placeholder='Выберите удобрение'
                                id="fertilizer-mineral-select"
                                value={fertilizers_mineral_list.find((f)=>f.value===row.fertilizer_id)}
                                options={fertilizers_mineral_list}
                                onChange={onFertilizerChange(row.id, 'fertilizer_id')}
                            />
                        </div>
                    );
                },
                id: 'organic',
                width: 30,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: 'Доза удобрения,\nт/га',
                value: (row, {focus}) => {
                    return (
                        <div className={this.colorBacklight(row.pH, row.soilId) + ' ' + (this.state.isCellChange.includes(row.id) ? 'change-cell' : '')}>
                            {/* eslint-disable-next-line eqeqeq */}
                            <div className={row.fertilizer_dose == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.fertilizer_dose)}
                                selectTextOnFocus={true}
                                focus={focus}
                                onChange={onLimingChange(row.id, 'fertilizer_dose')}
                            />
                            </div>
                        </div>
                    );
                },
                id: 'fertilizer_dose',
                width: 15
            }, {
                title: 'Стоимость удобрения, руб',
                value: (row, {focus}) => {
                    return (
                        <div className={this.colorBacklight(row.pH, row.soilId)}>
                            <Input
                                value={formatCell(row.price, true)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'price'
            }
            // , {
            //     title: 'Стоимость внесения\n руб/т',
            //     value: (row, {focus}) => {
            //         return (
            //             <div className={this.colorBacklight(row.pH, row.soilId)+(useInputPrice?'':' disable')}>
            //                 <Input
            //                     value={formatCell(row.intro_price, true)}
            //                     focus={focus}
            //                     selectTextOnFocus={true}
            //                     onChange={onLimingChange(row.id, 'intro_price')}
            //                 />
            //             </div>
            //         );
            //     },
            //     id: 'intro_price',
            // }
        ]


        this.setState({
            liming_columns: liming_columns,
            fertilizers_mineral_list: fertilizers_mineral_list,
            isCellChange: isCellChange
        });
    }
}
